import { Link } from "gatsby"
import React from "react"

const TenjinLink = props => {
  const item = props.item

  // Test if the link domain is the same of site or a relative link starting with '/',
  // so we can make it an internal link
  let externalLink = true
  let itemURL = item.url
  if (
    item?.url?.startsWith(process.env.GATSBY_BACKEND_URL) ||
    item?.url?.charAt(0) === "/"
  ) {
    externalLink = false
    itemURL = item.url.replace(process.env.GATSBY_BACKEND_URL, "")
    if (item.nodeType === "Post") {
      itemURL = `/blog${itemURL}`
    }
  }

  if (itemURL === "#") {
    return (
      <span className="text-base font-medium">
        {item.title ?? item.label}
      </span>
      )
  }

  return externalLink ? (
    <a
      className={`${props.className}`}
      href={item.url}
      aria-label={item.title ?? item.label}
      target={item.target}
      dangerouslySetInnerHTML={{ __html: item.title ?? item.label }}
    ></a>
  ) : (
    <Link
      className={`${props.className}`}
      activeClassName={`${props.activeClassName}`}
      to={itemURL.match(/\/$/) ? itemURL : `${itemURL}`}
      dangerouslySetInnerHTML={{ __html: item.title ?? item.label }}
    ></Link>
  )
}

export default TenjinLink
